/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const onboardingChallengeSchema = z.object({
  id: z.number(),
  slug: z.string(),
  title: z.string(),
  clipCount: z.number(),
});

export type IOnboardingChallenge = z.infer<typeof onboardingChallengeSchema>;

export const listOnboardingChallengesV1DataSchema = z.array(onboardingChallengeSchema);

export type IListOnboardingChallengesV1Data = z.infer<typeof listOnboardingChallengesV1DataSchema>;

export const listOnboardingChallengesV1ResponseSchema = createApiResponseSchema(
  listOnboardingChallengesV1DataSchema,
) as z.ZodSchema<IAPI<IListOnboardingChallengesV1Data>>;

export type IListOnboardingChallengesV1Response = IAPI<IListOnboardingChallengesV1Data>;
